import React from 'react';
import styles from './digital-header.scss';

const renderButtons = buttons => {
  return buttons ? (
    <div className={styles.headerButtonRow}>
      <a
        className={`${styles.headerButton} ${styles.headerButtonRowActive}`}
        href=""
      >
        Data Visualisation
      </a>
      <a className={styles.headerButton} href="">
        Accessible View
      </a>
    </div>
  ) : null;
};
const DigitalHeader = ({ buttons }) => {
  return (
    <div
      className={`${styles.digitalHeader} ${buttons ? styles.withButtons : ''}`}
    >
      <div className={styles.headerRow}>
        <div className={styles.headerColumnLeft}>
          <div className={styles.headerHeading}>
            Digital Government at a Glance
          </div>
        </div>
        <div className={styles.headerColumnRight}>
          <span>
            As part of NSW Government’s commitment to digital government
            transformation, clusters must report 6-monthly on their progress
            against{' '}
          </span>
          <a
            className={styles.headerLink}
            href="https://digital.nsw.gov.au/digital-government-priorities"
          >
            <span className={styles.headerLinkDescription}>
              Click here to learn more about the NSW Digital Government
              Strategy's three priorities
            </span>
            three priorities
          </a>
          <span>
            . Here you can see projects visualised in simple terms. We encourage
            you to explore and offer your{' '}
          </span>
          <a
            className={styles.headerLink}
            href="https://digital.nsw.gov.au/contact/feedback"
          >
            <span className={styles.headerLinkDescription}>
              Click here to go to the feedback form if you would like to leave
              feedback
            </span>
            feedback
          </a>.
          <div>
            <a
              className={styles.headerLink}
              href="https://digital.nsw.gov.au/clusters"
            >
              Learn more
              <span className={styles.headerLinkDescription}>
                click here to go to the accessible view of the whole of
                government data visualisation
              </span>
            </a>
          </div>
        </div>
      </div>
      {renderButtons(buttons)}
    </div>
  );
};

export default DigitalHeader;



// WEBPACK FOOTER //
// ./src/components/digital-header/digital-header.js